import type { StyleSpecification } from "maplibre-gl";

// Points every pmtiles:// vector source in the style at the given archive, so
// the archive comes from env rather than whatever the hosted style.json names.
export function withPMTilesSource(style: StyleSpecification, pmtilesUrl: string): StyleSpecification {
  const sources = Object.fromEntries(
    Object.entries(style.sources).map(([id, source]) =>
      source.type === "vector" && source.url?.startsWith("pmtiles://")
        ? [id, { ...source, url: `pmtiles://${pmtilesUrl}` }]
        : [id, source],
    ),
  );
  return { ...style, sources };
}
